var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSirius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 24,
    viewBox: "0 0 46 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3874 11.7201C7.89714 11.8137 7.39106 12.0381 6.99165 12.4454C6.57687 12.8684 6.3311 13.4351 6.30509 14.0951C3.1205 13.2157 1 10.7864 1 8.17876C1 4.91498 4.35329 1.92075 8.91079 1.92075C13.4635 1.92075 16.8243 4.91207 16.8508 8.18225C16.8505 8.34716 16.8321 8.52123 16.8049 8.75215C16.6261 9.55995 15.9577 11.5104 13.7891 11.8335C12.3511 12.0456 11.4569 11.9463 10.7553 11.8319C10.6597 11.8163 10.561 11.7986 10.4593 11.7804C9.86157 11.6733 9.16172 11.548 8.3874 11.7201Z",
    stroke: "#C2C2C2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5789 23.0793C41.0881 23.0793 39.9739 22.5143 39.2049 21.8552L40.1936 20.5056C40.8056 21.0392 41.5746 21.4001 42.5319 21.4001C43.3479 21.4001 43.9442 21.1333 43.9442 20.6469C43.9442 20.1133 43.2537 19.925 42.3749 19.721C41.1038 19.4385 39.456 19.0462 39.456 17.2258C39.456 15.5309 40.9469 14.6992 42.7202 14.6992C44.0855 14.6992 45.1055 15.1857 45.8274 15.7506L44.8387 17.1159C44.2581 16.6765 43.5833 16.3784 42.7672 16.3784C42.0768 16.3784 41.5118 16.5981 41.5118 17.0689C41.5118 17.6024 42.1866 17.775 43.0811 17.9634C44.3522 18.2458 46 18.6382 46 20.4585C46 22.1534 44.4935 23.0793 42.5789 23.0793Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7327 23.0793C32.4729 23.0793 30.9977 21.7454 30.9977 19.7053V14.8875H33.0378V19.4228C33.0378 20.4428 33.7126 21.102 34.7327 21.102C35.7527 21.102 36.4275 20.4428 36.4275 19.4228V14.8875H38.4676V19.7053C38.4676 21.7454 36.9768 23.0793 34.7327 23.0793Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6095 22.891V14.8875H29.6496V22.891H27.6095Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5424 14.762H26.8876V16.8648H26.5424C25.0829 16.8648 24.2355 17.728 24.2355 19.0932V22.891H22.1954V14.8875H24.2355V15.9233C24.8162 15.1857 25.6008 14.762 26.5424 14.762Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6817 22.891V14.8875H20.7218V22.891H18.6817Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3591 23.0793C12.8683 23.0793 11.7541 22.5143 10.9851 21.8552L11.9738 20.5056C12.5858 21.0392 13.3548 21.4001 14.312 21.4001C15.1281 21.4001 15.7244 21.1333 15.7244 20.6469C15.7244 20.1133 15.0339 19.925 14.1551 19.721C12.884 19.4385 11.2362 19.0462 11.2362 17.2258C11.2362 15.5309 12.727 14.6992 14.5003 14.6992C15.8656 14.6992 16.8857 15.1857 17.6076 15.7506L16.6189 17.1159C16.0383 16.6765 15.3635 16.3784 14.5474 16.3784C13.8569 16.3784 13.292 16.5981 13.292 17.0689C13.292 17.6024 13.9668 17.775 14.8613 17.9634C16.1324 18.2458 17.7802 18.6382 17.7802 20.4585C17.7802 22.1534 16.2737 23.0793 14.3591 23.0793Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6056 12.9847C18.6056 13.5975 19.0792 14.0636 19.6845 14.0636C20.2897 14.0636 20.7634 13.5975 20.7634 12.9847C20.7634 12.372 20.2897 11.9059 19.6845 11.9059C19.0792 11.9059 18.6056 12.372 18.6056 12.9847Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.531 12.9847C27.531 13.5975 28.0046 14.0636 28.6099 14.0636C29.2151 14.0636 29.6887 13.5975 29.6887 12.9847C29.6887 12.372 29.2151 11.9059 28.6099 11.9059C28.0046 11.9059 27.531 12.372 27.531 12.9847Z",
    fill: "#C2C2C2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSirius);
export default __webpack_public_path__ + "static/media/sirius.3af273e3a4a019beacadb8e4a44946e6.svg";
export { ForwardRef as ReactComponent };